import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSecondarySidebarStore } from '../stores/secondarySidebarStore';
import { PERSONAL_PAGES } from '../constants/constants';

/**
 * URL 변경을 감지하여 SecondarySidebar의 상태를 자동으로 업데이트하는 훅
 * PERSONAL_PAGES 경로에서는 사이드바를 축소하고, 다른 경로에서는 확장함
 *
 * 성능 최적화:
 * - 이전 상태와 비교하여 불필요한 업데이트 방지
 * - 메모이제이션을 통한 연산 최소화
 */
export const useSecondarySidebarSync = () => {
    const location = useLocation();
    const updateBasedOnUrl = useSecondarySidebarStore(
        state => state.updateBasedOnUrl
    );
    // const currentExpanded = useSecondarySidebarStore(state => state.isExpanded);

    // 이전 경로를 추적하여 불필요한 업데이트 방지
    const prevPathnameRef = useRef<string>('');

    useEffect(() => {
        const currentPathname = location.pathname.split('/')[1];

        // 경로가 실제로 변경된 경우에만 실행
        if (
            !prevPathnameRef.current ||
            prevPathnameRef.current !== currentPathname
        ) {
            // 새로운 상태 계산
            const shouldBeExpanded = !PERSONAL_PAGES.includes(currentPathname);

            // 사이드바 축소 필요할 때만 업데이트
            if (!shouldBeExpanded) {
                updateBasedOnUrl(currentPathname);
            }

            prevPathnameRef.current = currentPathname;
        }
    }, [location.pathname, updateBasedOnUrl]);
};
